import { sendMailUser } from "../actions/types";

const initialState = {
  loading: false,
  result: {},
};
const sendMailReducer = (state = initialState, action) => {
  switch (action.type) {
    case sendMailUser.SEND_MAIL_REQUEST:
      return {
        loading: true,
        result: {},
      };
    case sendMailUser.SEND_MAIL_SUCCESS:
      return {
        loading: false,
        result: action.payload,
      };
    case sendMailUser.SEND_MAIL_FAILURE:
      return {
        loading: false,
        result: action.payload,
      };

    case sendMailUser.CLOSE_MESSAGE:
      return {
        ...state,
        result: {},
      };
    default:
      return state;
  }
};

export default sendMailReducer;
